import React from "react";
import {ColumnProps} from "../Types/ColumnProps";

export default class DefaultEditable extends React.Component<ColumnProps, any> {

    render() {
        return null;
    }
}
